import React from 'react';
import useModal from '../../../../hooks/useModal';
import { noNaN } from '../../../../utils/util';
import {
  apiaFunctionsModalEmitter,
  TApiaFunctionsModalProps,
} from './ApiaFunctionsModals';
import { Modal } from '@apia/components';

const ApiaFunctionsModalChild = ({
  modal: { url, id, onClose, width, height, ...modalProps },
}: {
  modal: TApiaFunctionsModalProps;
}) => {
  const props = useModal({
    onExited: () =>
      apiaFunctionsModalEmitter.emit('close', {
        url,
        id,
        onClose,
        ...modalProps,
      }),
    isDefaultOpen: true,
  });

  return (
    <Modal
      {...props}
      {...modalProps}
      sx={React.useMemo(
        () => ({
          '.modal__main': {
            height: height ? `${noNaN(height, 50)}vw` : undefined,
            width: width ? `${noNaN(width, 50)}vw` : undefined,
          },
          variant: 'layout.common.modals.apiaFunctions',
        }),
        [height, width],
      )}
      data-variant="layout.common.modals.apiaFunctions"
    >
      <iframe src={url} title={modalProps.title} />
    </Modal>
  );
};

export default ApiaFunctionsModalChild;
